import script from "./wastewaterTreatment.vue?vue&type=script&setup=true&lang=js"
export * from "./wastewaterTreatment.vue?vue&type=script&setup=true&lang=js"

import "./wastewaterTreatment.vue?vue&type=style&index=0&id=c6f5361a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6f5361a"]])

export default __exports__